// @ts-check
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../StateProvider'
import { ButtonLink } from '../../../ui/ButtonLink/ButtonLink'
import { ResendEmailFormBase } from '../../ResendEmailFormBase/ResendEmailFormBase'
import { isNil } from 'ramda'
import cn from 'classnames'
import styles from './style.css'

/**
 * @param {{resendToken: function, isLoadingResend: boolean}} props
 */
const ResendEmailForm = ({ resendToken, isLoadingResend }) => {
  const { t } = useTranslation()
  const [{ form: { isResendOpen }, flags: { isResendFormShown }, whitelabel: { hideCreateAccountResendLink } }] = useStore()
  const [isShown, setIsShown] = useState(true)
  const [isFormShown, setIsFormShown] = useState(false)

  const toggleShowResend = () => setIsFormShown(!isFormShown)

  useEffect(() => {
    if (isNil(isResendFormShown)) return
    setIsShown(isResendFormShown)
  }, [isResendFormShown])

  useEffect(() => {
    setIsFormShown(isResendOpen)
  }, [isResendOpen])

  return isShown ? (
    <div className={styles.resendForm}>
      {!hideCreateAccountResendLink && (
        <div className={styles.buttonWrapper}>
          <ButtonLink className={styles.buttonLink} onClick={toggleShowResend}>
            {t('createAccount.resendLink')}
          </ButtonLink>
        </div>
      )}
      <ResendEmailFormBase
        resendToken={resendToken}
        isLoadingResend={isLoadingResend}
        className={cn({ [styles.hidden]: !isFormShown })}
      />
    </div>
  ) : null
}

export { ResendEmailForm }
